import {dealData} from "./deal";
import axios from "axios";
import {getBackendURL, httpResponse, httpResponseError} from "../../fn";

/**
 * Получить текущий статус по сделке
 * @returns {*}
 */
export const getCurrentStatus = () => {
  return dealData.statuses[0]?.status;
}

/**
 * Имеется ли статус в статус листе
 * @returns {*}
 */
export const hasStatus = (status) => {
  const result = dealData?.statuses.findIndex((item) => item.status === status);

  return result === -1 ? false : true;
}

export const reloadStatus = async (dealId) => {
  const result = await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/deal/${dealId}/statuses`, {
      withCredentials: true,
      headers: {
        'content-type': 'application/json',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error))
    });
  })
  dealData.statuses = result?.data || dealData.statuses;
}